import { render, staticRenderFns } from "./TheMyFavoritesRemoveListItemDialog.vue?vue&type=template&id=6b959ee5&scoped=true"
import script from "./TheMyFavoritesRemoveListItemDialog.vue?vue&type=script&lang=js"
export * from "./TheMyFavoritesRemoveListItemDialog.vue?vue&type=script&lang=js"
import style0 from "./TheMyFavoritesRemoveListItemDialog.vue?vue&type=style&index=0&id=6b959ee5&prod&lang=scss&scoped=true"
import style1 from "./TheMyFavoritesRemoveListItemDialog.vue?vue&type=style&index=1&id=6b959ee5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b959ee5",
  null
  
)

export default component.exports